import React from 'react';

import styled from 'styled-components';
import { Block, Text } from '../../../components/typography';
import { getIcon, getRewardCardMessagesAndIcons } from './get-rewards-card-messages-and-icons';
import { withRootClassName } from '../../../lib';
import { useDeviceInfo } from '../../../retail-config/device';

const withClassName = withRootClassName('qa-rewards-card-information-component');

export const RewardsCardInformationComponent = ({
  isManualEntryEnabled,
  playerCardProvider
}: {
  isManualEntryEnabled?: boolean;
  playerCardProvider: string;
}) => {
  const { rewardsModal, brand } = useDeviceInfo();

  const messagesAndIcons = getRewardCardMessagesAndIcons({
    playerCardProvider,
    rewardsModal,
    brand
  });

  const FirstIcon = getIcon(messagesAndIcons.icons.first);
  const SecondIcon = messagesAndIcons.icons?.second && getIcon(messagesAndIcons.icons?.second);
  const ThirdIcon = messagesAndIcons.icons?.third && getIcon(messagesAndIcons.icons?.third);

  return (
    <RewardsCardInformationWrapper
      spaceEvenly={Boolean(ThirdIcon) && isManualEntryEnabled}
      showBorder={isManualEntryEnabled}>
      <FlexColumn>
        <TextOne weight="bold" isManualEntryEnabled={isManualEntryEnabled}>
          {messagesAndIcons.messages.first}
        </TextOne>
        <div data-testid={withClassName('first-icon')}>
          <FirstIcon />
        </div>
      </FlexColumn>
      {isManualEntryEnabled && SecondIcon && (
        <>
          <VerticalTextBar />
          <FlexColumn>
            <TextTwo weight="bold">{messagesAndIcons.messages.second}</TextTwo>
            <FlexCentered data-testid={withClassName('second-icon')}>
              <SecondIcon />
            </FlexCentered>
          </FlexColumn>
        </>
      )}
      {isManualEntryEnabled && ThirdIcon && (
        <>
          <VerticalTextBar />
          <FlexColumn>
            <TextOne weight="bold" isManualEntryEnabled={isManualEntryEnabled}>
              {messagesAndIcons.messages.third}
            </TextOne>
            <FlexCentered data-testid={withClassName('third-icon')}>
              <ThirdIcon />
            </FlexCentered>
          </FlexColumn>
        </>
      )}
    </RewardsCardInformationWrapper>
  );
};

const RewardsCardInformationWrapper = styled.div<{ spaceEvenly?: boolean; showBorder?: boolean }>`
  width: 100%;
  display: flex;
  ${({ spaceEvenly }) =>
    spaceEvenly
      ? `
          justify-content: space-evenly;
          `
      : `
          justify-content: center;
          padding-bottom: 2rem;
          > * + * {
            margin-left: 3rem;
          }
    `}
  ${({ showBorder, theme }) => showBorder && `border-bottom: 1px solid ${theme.colors.modals.neutral};`}
  padding-top: 2rem;
  margin-bottom: ${({ showBorder }) => (showBorder ? '3rem' : '1rem')};
`;

const TextOne = styled(Text)<{ isManualEntryEnabled?: boolean }>`
  width: ${({ isManualEntryEnabled }) => (isManualEntryEnabled ? '20rem' : '23rem')};
`;

const TextTwo = styled(Text)`
  width: 20rem;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: 3rem;
  }
`;

const FlexCentered = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const VerticalTextBar = () => {
  return (
    <VerticalTextBarWrapper>
      <FlexBlock weight="bold">
        <Circle>
          <Text>or</Text>
        </Circle>
      </FlexBlock>
      <VerticalBar />
    </VerticalTextBarWrapper>
  );
};

const VerticalTextBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > * + * {
    margin: 0 3rem;
  }
`;

const FlexBlock = styled(Block)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 3.2rem;
  width: 3.2rem;
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin: 1rem 0;
`;

const VerticalBar = styled.div`
  height: 18rem;
  border-left: 1px solid ${({ theme }) => theme.colors.modals.neutral};
  margin-top: 4rem;
`;
